import { commentTypeQuestion } from "constants/questionTypes";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { words } from "../translations";
import SkipCheckbox from "../Components/SkipCheckbox";

const Comments = ({ question, saveUpdatedAnswers, currentQuestionDet, language, organizationInfo, customHeader }) => {
  // console.log("question", question)

  const textareaRef = useRef();
  const [feedbackText, setFeedbackText] = useState('');
  const [isNA, setIsNA] = useState(false);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 16}px`;
    }
  }, []);

  const handleInput = (e) => {
    e.target.style.height = 'inherit';
    e.target.style.height = `${e.target.scrollHeight - 16}px`;
  };

  const handleChange = (event) => {
    setFeedbackText(event.target.value);
    const ResponseObj = {
      ques_sort_order: currentQuestionDet?.id,
      survey_q_id: currentQuestionDet.id,
      feedback: event.target.value,
      question_type: currentQuestionDet?.question_type,
      clicked: true,
    }

    saveUpdatedAnswers(currentQuestionDet?.id, ResponseObj, commentTypeQuestion)
  };

  const handleNAClick = () => {
    setIsNA(!isNA);
    
    const ResponseObj = {
      ques_sort_order: currentQuestionDet?.id,
      survey_q_id: currentQuestionDet.id,
      feedback: '',
      question_type: currentQuestionDet?.question_type,
      clicked: true,
      skipped: !isNA
    }
    
    if (!isNA) {
      setFeedbackText('');
    }
    
    saveUpdatedAnswers(currentQuestionDet?.id, ResponseObj, commentTypeQuestion);
  };

  useEffect(() => {
    if (currentQuestionDet?.response) {
      setFeedbackText(currentQuestionDet?.response?.feedback || '');
      setIsNA(currentQuestionDet?.response?.skipped || false);
    } else {
      setFeedbackText('');
      setIsNA(false);
    }
  }, [currentQuestionDet]);



  return (
    <FeedbackContainer>
      {customHeader?.useImageAsQualifier && customHeader?.imageUrl ? (
        <HeaderImage
          src={customHeader.imageUrl}
          alt=""
          $height={customHeader.imageHeight}
        />
      ) : (
        <Title style={{color: organizationInfo?.custom_survey_header_color || undefined}}>{words['Feedback'][language]}</Title>
      )}
      <Description>
      {language === 'FR'? question?.fr : question?.question}
      </Description>

      <StyledTextarea
        id={`txt_${currentQuestionDet?.id}`}
        value={feedbackText}
        onChange={handleChange}
        placeholder={language == "FR" ? "Tapez votre réponse ici" :"Type your answer here"}
        ref={textareaRef}
        onInput={handleInput} />

  {currentQuestionDet?.allowSkipComments && (
        <SkipCheckbox
          id={`skip_${currentQuestionDet?.id}`}
          selected={isNA}
          onClick={handleNAClick}
          language={language}
        />
      )}
    </FeedbackContainer>

  )

}

export default Comments



const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width:600px;
  width:100%;
  font-family: 'Raleway', sans-serif;
`;

const HeaderImage = styled.img`
  display: block;
  max-width: 100%;
  height: ${props => (props.$height ? `${props.$height}px` : "auto")};
  margin-bottom: 40px;
`;

const Description = styled.div`
color: #2A3039;
font-family: 'Raleway';
font-style: normal;
font-weight: 400;
font-size: 16px;
margin-bottom:34px;
line-height:1.6;
`
const Title = styled.div`
color: #2D70E2;
text-transform: uppercase;
font-size:14px;
font-weight:600;
margin-bottom:40px;
`

const StyledTextarea = styled.textarea`
  display: block;
  width: 100%; 
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #2A3039;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: none;
  font-family: 'Raleway', sans-serif;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2D70E2;
    outline: 0;
  }
`;


const NA = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-family: "Barlow", sans-serif;
  background-color: ${props => props.selected ? '#D5E2F9' : '#fff'};
  color: #333;
  height: 30px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 75px;
  margin-top: 50px;
  cursor: pointer;
  margin-right: -20px;
  transition: all 0.3s ease;
  border: 2px solid ${props => props.selected ? '#2D70E2' : 'transparent'};
  
  &:hover {
    background-color: #D5E2F9;
  }

  @media(max-width:768px){
    margin-right: -10px;
  }
`